import { useMemo as e, useState as i, useCallback as t, createElement as n, Fragment as r, useRef as a, useEffect as o } from "react";
import { usePropertyAccessor as d, useValueFormatter as l, degreesToRadians as s, radiansToDegrees as c, Container as u, useDimensions as v, bindDefs as f, SvgWrapper as g, ResponsiveWrapper as L, useTheme as h, getRelativeCursor as b } from "@nivo/core";
import { useArcGenerator as p, computeArcBoundingBox as k, ArcsLayer as A, ArcLinkLabelsLayer as R, ArcLabelsLayer as m, useArcLabels as O, useArcLinkLabels as C, drawCanvasArcLinkLabels as I, drawCanvasArcLabels as x, findArcUnderCursor as M } from "@nivo/arcs";
import { BoxLegendSvg as y, renderLegendToCanvas as w } from "@nivo/legends";
import { jsx as W, Fragment as S } from "react/jsx-runtime";
import { pie as T } from "d3-shape";
import { useOrdinalColorScale as V, useInheritedColor as B } from "@nivo/colors";
import { BasicTooltip as G, useTooltip as E } from "@nivo/tooltip";

function D() {
  return D = Object.assign || function (e) {
    for (var i = 1; i < arguments.length; i++) {
      var t = arguments[i];

      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }

    return e;
  }, D.apply(this, arguments);
}

function F(e, i) {
  if (null == e) return {};
  var t,
      n,
      r = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) t = a[n], i.indexOf(t) >= 0 || (r[t] = e[t]);

  return r;
}

var H,
    X = function (e) {
  var i = e.width,
      t = e.height,
      n = e.legends,
      r = e.data,
      a = e.toggleSerie;
  return W(S, {
    children: n.map(function (e, n) {
      var o;
      return W(y, D({}, e, {
        containerWidth: i,
        containerHeight: t,
        data: null != (o = e.data) ? o : r,
        toggleSerie: e.toggleSerie ? a : void 0
      }), n);
    })
  });
},
    Y = {
  id: "id",
  value: "value",
  sortByValue: !1,
  innerRadius: 0,
  padAngle: 0,
  cornerRadius: 0,
  layers: ["arcLinkLabels", "arcs", "arcLabels", "legends"],
  startAngle: 0,
  endAngle: 360,
  fit: !0,
  activeInnerRadiusOffset: 0,
  activeOuterRadiusOffset: 0,
  borderWidth: 0,
  borderColor: {
    from: "color",
    modifiers: [["darker", 1]]
  },
  enableArcLabels: !0,
  arcLabel: "formattedValue",
  arcLabelsSkipAngle: 0,
  arcLabelsRadiusOffset: .5,
  arcLabelsTextColor: {
    theme: "labels.text.fill"
  },
  enableArcLinkLabels: !0,
  arcLinkLabel: "id",
  arcLinkLabelsSkipAngle: 0,
  arcLinkLabelsOffset: 0,
  arcLinkLabelsDiagonalLength: 16,
  arcLinkLabelsStraightLength: 24,
  arcLinkLabelsThickness: 1,
  arcLinkLabelsTextOffset: 6,
  arcLinkLabelsTextColor: {
    theme: "labels.text.fill"
  },
  arcLinkLabelsColor: {
    theme: "axis.ticks.line.stroke"
  },
  colors: {
    scheme: "nivo"
  },
  defs: [],
  fill: [],
  isInteractive: !0,
  animate: !0,
  motionConfig: "gentle",
  transitionMode: "innerRadius",
  tooltip: function (e) {
    var i = e.datum;
    return W(G, {
      id: i.id,
      value: i.formattedValue,
      enableChip: !0,
      color: i.color
    });
  },
  legends: [],
  role: "img",
  pixelRatio: "undefined" != typeof window && null != (H = window.devicePixelRatio) ? H : 1
},
    j = ["points"],
    P = function (i) {
  var t = i.data,
      n = i.id,
      r = void 0 === n ? Y.id : n,
      a = i.value,
      o = void 0 === a ? Y.value : a,
      s = i.valueFormat,
      c = i.colors,
      u = void 0 === c ? Y.colors : c,
      v = d(r),
      f = d(o),
      g = l(s),
      L = V(u, "id");
  return e(function () {
    return t.map(function (e) {
      var i,
          t = v(e),
          n = f(e),
          r = {
        id: t,
        label: null != (i = e.label) ? i : t,
        hidden: !1,
        value: n,
        formattedValue: g(n),
        data: e
      };
      return D({}, r, {
        color: L(r)
      });
    });
  }, [t, v, f, g, L]);
},
    q = function (i) {
  var t = i.data,
      n = i.startAngle,
      r = i.endAngle,
      a = i.innerRadius,
      o = i.outerRadius,
      d = i.padAngle,
      l = i.sortByValue,
      u = i.activeId,
      v = i.activeInnerRadiusOffset,
      f = i.activeOuterRadiusOffset,
      g = i.hiddenIds,
      L = e(function () {
    var e = T().value(function (e) {
      return e.value;
    }).startAngle(s(n)).endAngle(s(r)).padAngle(s(d));
    return l || e.sortValues(null), e;
  }, [n, r, d, l]);
  return e(function () {
    var e = t.filter(function (e) {
      return !g.includes(e.id);
    });
    return {
      dataWithArc: L(e).map(function (e) {
        var i = Math.abs(e.endAngle - e.startAngle);
        return D({}, e.data, {
          arc: {
            index: e.index,
            startAngle: e.startAngle,
            endAngle: e.endAngle,
            innerRadius: u === e.data.id ? a - v : a,
            outerRadius: u === e.data.id ? o + f : o,
            thickness: o - a,
            padAngle: e.padAngle,
            angle: i,
            angleDeg: c(i)
          }
        });
      }),
      legendData: t.map(function (e) {
        return D({}, e, {
          hidden: g.includes(e.id)
        });
      })
    };
  }, [L, t, g, u, a, v, o, f]);
},
    z = function (e) {
  var n = e.data,
      r = e.radius,
      a = e.innerRadius,
      o = e.startAngle,
      d = void 0 === o ? Y.startAngle : o,
      l = e.endAngle,
      c = void 0 === l ? Y.endAngle : l,
      u = e.padAngle,
      v = void 0 === u ? Y.padAngle : u,
      f = e.sortByValue,
      g = void 0 === f ? Y.sortByValue : f,
      L = e.cornerRadius,
      h = void 0 === L ? Y.cornerRadius : L,
      b = e.activeInnerRadiusOffset,
      k = void 0 === b ? Y.activeInnerRadiusOffset : b,
      A = e.activeOuterRadiusOffset,
      R = void 0 === A ? Y.activeOuterRadiusOffset : A,
      m = i(null),
      O = m[0],
      C = m[1],
      I = i([]),
      x = I[0],
      M = I[1],
      y = q({
    data: n,
    startAngle: d,
    endAngle: c,
    innerRadius: a,
    outerRadius: r,
    padAngle: v,
    sortByValue: g,
    activeId: O,
    activeInnerRadiusOffset: k,
    activeOuterRadiusOffset: R,
    hiddenIds: x
  }),
      w = t(function (e) {
    M(function (i) {
      return i.indexOf(e) > -1 ? i.filter(function (i) {
        return i !== e;
      }) : [].concat(i, [e]);
    });
  }, []);
  return D({}, y, {
    arcGenerator: p({
      cornerRadius: h,
      padAngle: s(v)
    }),
    setActiveId: C,
    toggleSerie: w
  });
},
    J = function (n) {
  var r = n.data,
      a = n.width,
      o = n.height,
      d = n.innerRadius,
      l = void 0 === d ? Y.innerRadius : d,
      c = n.startAngle,
      u = void 0 === c ? Y.startAngle : c,
      v = n.endAngle,
      f = void 0 === v ? Y.endAngle : v,
      g = n.padAngle,
      L = void 0 === g ? Y.padAngle : g,
      h = n.sortByValue,
      b = void 0 === h ? Y.sortByValue : h,
      A = n.cornerRadius,
      R = void 0 === A ? Y.cornerRadius : A,
      m = n.fit,
      O = void 0 === m ? Y.fit : m,
      C = n.activeInnerRadiusOffset,
      I = void 0 === C ? Y.activeInnerRadiusOffset : C,
      x = n.activeOuterRadiusOffset,
      M = void 0 === x ? Y.activeOuterRadiusOffset : x,
      y = i(null),
      w = y[0],
      W = y[1],
      S = i([]),
      T = S[0],
      V = S[1],
      B = e(function () {
    var e,
        i = Math.min(a, o) / 2,
        t = i * Math.min(l, 1),
        n = a / 2,
        r = o / 2;

    if (O) {
      var d = k(n, r, i, u - 90, f - 90),
          s = d.points,
          c = F(d, j),
          v = Math.min(a / c.width, o / c.height),
          g = {
        width: c.width * v,
        height: c.height * v
      };
      g.x = (a - g.width) / 2, g.y = (o - g.height) / 2, n = (n - c.x) / c.width * c.width * v + g.x, r = (r - c.y) / c.height * c.height * v + g.y, e = {
        box: c,
        ratio: v,
        points: s
      }, i *= v, t *= v;
    }

    return {
      centerX: n,
      centerY: r,
      radius: i,
      innerRadius: t,
      debug: e
    };
  }, [a, o, l, u, f, O, R]),
      G = q({
    data: r,
    startAngle: u,
    endAngle: f,
    innerRadius: B.innerRadius,
    outerRadius: B.radius,
    padAngle: L,
    sortByValue: b,
    activeId: w,
    activeInnerRadiusOffset: I,
    activeOuterRadiusOffset: M,
    hiddenIds: T
  }),
      E = t(function (e) {
    V(function (i) {
      return i.indexOf(e) > -1 ? i.filter(function (i) {
        return i !== e;
      }) : [].concat(i, [e]);
    });
  }, []);
  return D({
    arcGenerator: p({
      cornerRadius: R,
      padAngle: s(L)
    }),
    setActiveId: W,
    toggleSerie: E
  }, G, B);
},
    K = function (i) {
  var t = i.dataWithArc,
      n = i.arcGenerator,
      r = i.centerX,
      a = i.centerY,
      o = i.radius,
      d = i.innerRadius;
  return e(function () {
    return {
      dataWithArc: t,
      arcGenerator: n,
      centerX: r,
      centerY: a,
      radius: o,
      innerRadius: d
    };
  }, [t, n, r, a, o, d]);
},
    N = function (i) {
  var t = i.center,
      r = i.data,
      a = i.arcGenerator,
      o = i.borderWidth,
      d = i.borderColor,
      l = i.isInteractive,
      s = i.onClick,
      c = i.onMouseEnter,
      u = i.onMouseMove,
      v = i.onMouseLeave,
      f = i.setActiveId,
      g = i.tooltip,
      L = i.transitionMode,
      h = E(),
      b = h.showTooltipFromEvent,
      p = h.hideTooltip,
      k = e(function () {
    if (l) return function (e, i) {
      null == s || s(e, i);
    };
  }, [l, s]),
      R = e(function () {
    if (l) return function (e, i) {
      b(n(g, {
        datum: e
      }), i), f(e.id), null == c || c(e, i);
    };
  }, [l, b, f, c, g]),
      m = e(function () {
    if (l) return function (e, i) {
      b(n(g, {
        datum: e
      }), i), null == u || u(e, i);
    };
  }, [l, b, u, g]),
      O = e(function () {
    if (l) return function (e, i) {
      p(), f(null), null == v || v(e, i);
    };
  }, [l, p, f, v]);
  return W(A, {
    center: t,
    data: r,
    arcGenerator: a,
    borderWidth: o,
    borderColor: d,
    transitionMode: L,
    onClick: k,
    onMouseEnter: R,
    onMouseMove: m,
    onMouseLeave: O
  });
},
    Q = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
    U = function (e) {
  var i = e.data,
      t = e.id,
      a = void 0 === t ? Y.id : t,
      o = e.value,
      d = void 0 === o ? Y.value : o,
      l = e.valueFormat,
      s = e.sortByValue,
      c = void 0 === s ? Y.sortByValue : s,
      u = e.layers,
      L = void 0 === u ? Y.layers : u,
      h = e.startAngle,
      b = void 0 === h ? Y.startAngle : h,
      p = e.endAngle,
      k = void 0 === p ? Y.endAngle : p,
      A = e.padAngle,
      O = void 0 === A ? Y.padAngle : A,
      C = e.fit,
      I = void 0 === C ? Y.fit : C,
      x = e.innerRadius,
      M = void 0 === x ? Y.innerRadius : x,
      y = e.cornerRadius,
      w = void 0 === y ? Y.cornerRadius : y,
      S = e.activeInnerRadiusOffset,
      T = void 0 === S ? Y.activeInnerRadiusOffset : S,
      V = e.activeOuterRadiusOffset,
      B = void 0 === V ? Y.activeOuterRadiusOffset : V,
      G = e.width,
      E = e.height,
      D = e.margin,
      F = e.colors,
      H = void 0 === F ? Y.colors : F,
      j = e.borderWidth,
      q = void 0 === j ? Y.borderWidth : j,
      z = e.borderColor,
      Q = void 0 === z ? Y.borderColor : z,
      U = e.enableArcLabels,
      Z = void 0 === U ? Y.enableArcLabels : U,
      $ = e.arcLabel,
      _ = void 0 === $ ? Y.arcLabel : $,
      ee = e.arcLabelsSkipAngle,
      ie = void 0 === ee ? Y.arcLabelsSkipAngle : ee,
      te = e.arcLabelsTextColor,
      ne = void 0 === te ? Y.arcLabelsTextColor : te,
      re = e.arcLabelsRadiusOffset,
      ae = void 0 === re ? Y.arcLabelsRadiusOffset : re,
      oe = e.arcLabelsComponent,
      de = e.enableArcLinkLabels,
      le = void 0 === de ? Y.enableArcLinkLabels : de,
      se = e.arcLinkLabel,
      ce = void 0 === se ? Y.arcLinkLabel : se,
      ue = e.arcLinkLabelsSkipAngle,
      ve = void 0 === ue ? Y.arcLinkLabelsSkipAngle : ue,
      fe = e.arcLinkLabelsOffset,
      ge = void 0 === fe ? Y.arcLinkLabelsOffset : fe,
      Le = e.arcLinkLabelsDiagonalLength,
      he = void 0 === Le ? Y.arcLinkLabelsDiagonalLength : Le,
      be = e.arcLinkLabelsStraightLength,
      pe = void 0 === be ? Y.arcLinkLabelsStraightLength : be,
      ke = e.arcLinkLabelsThickness,
      Ae = void 0 === ke ? Y.arcLinkLabelsThickness : ke,
      Re = e.arcLinkLabelsTextOffset,
      me = void 0 === Re ? Y.arcLinkLabelsTextOffset : Re,
      Oe = e.arcLinkLabelsTextColor,
      Ce = void 0 === Oe ? Y.arcLinkLabelsTextColor : Oe,
      Ie = e.arcLinkLabelsColor,
      xe = void 0 === Ie ? Y.arcLinkLabelsColor : Ie,
      Me = e.arcLinkLabelComponent,
      ye = e.defs,
      we = void 0 === ye ? Y.defs : ye,
      We = e.fill,
      Se = void 0 === We ? Y.fill : We,
      Te = e.isInteractive,
      Ve = void 0 === Te ? Y.isInteractive : Te,
      Be = e.onClick,
      Ge = e.onMouseEnter,
      Ee = e.onMouseMove,
      De = e.onMouseLeave,
      Fe = e.tooltip,
      He = void 0 === Fe ? Y.tooltip : Fe,
      Xe = e.transitionMode,
      Ye = void 0 === Xe ? Y.transitionMode : Xe,
      je = e.legends,
      Pe = void 0 === je ? Y.legends : je,
      qe = e.role,
      ze = void 0 === qe ? Y.role : qe,
      Je = v(G, E, D),
      Ke = Je.outerWidth,
      Ne = Je.outerHeight,
      Qe = Je.margin,
      Ue = Je.innerWidth,
      Ze = Je.innerHeight,
      $e = P({
    data: i,
    id: a,
    value: d,
    valueFormat: l,
    colors: H
  }),
      _e = J({
    data: $e,
    width: Ue,
    height: Ze,
    fit: I,
    innerRadius: M,
    startAngle: b,
    endAngle: k,
    padAngle: O,
    sortByValue: c,
    cornerRadius: w,
    activeInnerRadiusOffset: T,
    activeOuterRadiusOffset: B
  }),
      ei = _e.dataWithArc,
      ii = _e.legendData,
      ti = _e.arcGenerator,
      ni = _e.centerX,
      ri = _e.centerY,
      ai = _e.radius,
      oi = _e.innerRadius,
      di = _e.setActiveId,
      li = _e.toggleSerie,
      si = f(we, ei, Se),
      ci = {
    arcLinkLabels: null,
    arcs: null,
    arcLabels: null,
    legends: null
  };

  le && L.includes("arcLinkLabels") && (ci.arcLinkLabels = W(R, {
    center: [ni, ri],
    data: ei,
    label: ce,
    skipAngle: ve,
    offset: ge,
    diagonalLength: he,
    straightLength: pe,
    strokeWidth: Ae,
    textOffset: me,
    textColor: Ce,
    linkColor: xe,
    component: Me
  }, "arcLinkLabels")), L.includes("arcs") && (ci.arcs = W(N, {
    center: [ni, ri],
    data: ei,
    arcGenerator: ti,
    borderWidth: q,
    borderColor: Q,
    isInteractive: Ve,
    onClick: Be,
    onMouseEnter: Ge,
    onMouseMove: Ee,
    onMouseLeave: De,
    setActiveId: di,
    tooltip: He,
    transitionMode: Ye
  }, "arcs")), Z && L.includes("arcLabels") && (ci.arcLabels = W(m, {
    center: [ni, ri],
    data: ei,
    label: _,
    radiusOffset: ae,
    skipAngle: ie,
    textColor: ne,
    transitionMode: Ye,
    component: oe
  }, "arcLabels")), Pe.length > 0 && L.includes("legends") && (ci.legends = W(X, {
    width: Ue,
    height: Ze,
    data: ii,
    legends: Pe,
    toggleSerie: li
  }, "legends"));
  var ui = K({
    dataWithArc: ei,
    arcGenerator: ti,
    centerX: ni,
    centerY: ri,
    radius: ai,
    innerRadius: oi
  });
  return W(g, {
    width: Ke,
    height: Ne,
    margin: Qe,
    defs: si,
    role: ze,
    children: L.map(function (e, i) {
      return void 0 !== ci[e] ? ci[e] : "function" == typeof e ? W(r, {
        children: n(e, ui)
      }, i) : null;
    })
  });
},
    Z = function (e) {
  var i = e.isInteractive,
      t = void 0 === i ? Y.isInteractive : i,
      n = e.animate,
      r = void 0 === n ? Y.animate : n,
      a = e.motionConfig,
      o = void 0 === a ? Y.motionConfig : a,
      d = e.theme,
      l = e.renderWrapper,
      s = F(e, Q);
  return W(u, {
    animate: r,
    isInteractive: t,
    motionConfig: o,
    renderWrapper: l,
    theme: d,
    children: W(U, D({
      isInteractive: t
    }, s))
  });
},
    $ = function (e) {
  return W(L, {
    children: function (i) {
      var t = i.width,
          n = i.height;
      return W(Z, D({
        width: t,
        height: n
      }, e));
    }
  });
},
    _ = ["isInteractive", "theme", "renderWrapper"],
    ee = function (i) {
  var t = i.data,
      r = i.id,
      d = void 0 === r ? Y.id : r,
      l = i.value,
      s = void 0 === l ? Y.value : l,
      c = i.valueFormat,
      u = i.sortByValue,
      f = void 0 === u ? Y.sortByValue : u,
      g = i.startAngle,
      L = void 0 === g ? Y.startAngle : g,
      p = i.endAngle,
      k = void 0 === p ? Y.endAngle : p,
      A = i.padAngle,
      R = void 0 === A ? Y.padAngle : A,
      m = i.fit,
      y = void 0 === m ? Y.fit : m,
      S = i.innerRadius,
      T = void 0 === S ? Y.innerRadius : S,
      V = i.cornerRadius,
      G = void 0 === V ? Y.cornerRadius : V,
      F = i.activeInnerRadiusOffset,
      H = void 0 === F ? Y.activeInnerRadiusOffset : F,
      X = i.activeOuterRadiusOffset,
      j = void 0 === X ? Y.activeOuterRadiusOffset : X,
      q = i.width,
      z = i.height,
      K = i.margin,
      N = i.pixelRatio,
      Q = void 0 === N ? 1 : N,
      U = i.colors,
      Z = void 0 === U ? Y.colors : U,
      $ = i.borderWidth,
      _ = void 0 === $ ? Y.borderWidth : $,
      ee = i.borderColor,
      ie = void 0 === ee ? Y.borderColor : ee,
      te = i.enableArcLabels,
      ne = void 0 === te ? Y.enableArcLabels : te,
      re = i.arcLabel,
      ae = void 0 === re ? Y.arcLabel : re,
      oe = i.arcLabelsSkipAngle,
      de = void 0 === oe ? Y.arcLabelsSkipAngle : oe,
      le = i.arcLabelsTextColor,
      se = void 0 === le ? Y.arcLabelsTextColor : le,
      ce = i.arcLabelsRadiusOffset,
      ue = void 0 === ce ? Y.arcLabelsRadiusOffset : ce,
      ve = i.enableArcLinkLabels,
      fe = void 0 === ve ? Y.enableArcLinkLabels : ve,
      ge = i.arcLinkLabel,
      Le = void 0 === ge ? Y.arcLinkLabel : ge,
      he = i.arcLinkLabelsSkipAngle,
      be = void 0 === he ? Y.arcLinkLabelsSkipAngle : he,
      pe = i.arcLinkLabelsOffset,
      ke = void 0 === pe ? Y.arcLinkLabelsOffset : pe,
      Ae = i.arcLinkLabelsDiagonalLength,
      Re = void 0 === Ae ? Y.arcLinkLabelsDiagonalLength : Ae,
      me = i.arcLinkLabelsStraightLength,
      Oe = void 0 === me ? Y.arcLinkLabelsStraightLength : me,
      Ce = i.arcLinkLabelsThickness,
      Ie = void 0 === Ce ? Y.arcLinkLabelsThickness : Ce,
      xe = i.arcLinkLabelsTextOffset,
      Me = void 0 === xe ? Y.arcLinkLabelsTextOffset : xe,
      ye = i.arcLinkLabelsTextColor,
      we = void 0 === ye ? Y.arcLinkLabelsTextColor : ye,
      We = i.arcLinkLabelsColor,
      Se = void 0 === We ? Y.arcLinkLabelsColor : We,
      Te = i.isInteractive,
      Ve = void 0 === Te ? Y.isInteractive : Te,
      Be = i.onClick,
      Ge = i.onMouseMove,
      Ee = i.tooltip,
      De = void 0 === Ee ? Y.tooltip : Ee,
      Fe = i.legends,
      He = void 0 === Fe ? Y.legends : Fe,
      Xe = a(null),
      Ye = h(),
      je = v(q, z, K),
      Pe = je.margin,
      qe = je.innerWidth,
      ze = je.innerHeight,
      Je = je.outerWidth,
      Ke = je.outerHeight,
      Ne = P({
    data: t,
    id: d,
    value: s,
    valueFormat: c,
    colors: Z
  }),
      Qe = J({
    data: Ne,
    width: qe,
    height: ze,
    fit: y,
    innerRadius: T,
    startAngle: L,
    endAngle: k,
    padAngle: R,
    sortByValue: f,
    cornerRadius: G,
    activeInnerRadiusOffset: H,
    activeOuterRadiusOffset: j
  }),
      Ue = Qe.dataWithArc,
      Ze = Qe.arcGenerator,
      $e = Qe.centerX,
      _e = Qe.centerY,
      ei = Qe.radius,
      ii = Qe.innerRadius,
      ti = Qe.setActiveId,
      ni = B(ie, Ye),
      ri = O({
    data: Ue,
    label: ae,
    skipAngle: de,
    offset: ue,
    textColor: se
  }),
      ai = C({
    data: Ue,
    skipAngle: be,
    offset: ke,
    diagonalLength: Re,
    straightLength: Oe,
    label: Le,
    linkColor: Se,
    textOffset: Me,
    textColor: we
  });

  o(function () {
    if (Xe.current) {
      Xe.current.width = Je * Q, Xe.current.height = Ke * Q;
      var e = Xe.current.getContext("2d");
      e.scale(Q, Q), e.fillStyle = Ye.background, e.fillRect(0, 0, Je, Ke), e.save(), e.translate(Pe.left, Pe.top), Ze.context(e), e.save(), e.translate($e, _e), Ue.forEach(function (i) {
        e.beginPath(), e.fillStyle = i.color, e.strokeStyle = ni(i), e.lineWidth = _, Ze(i.arc), e.fill(), _ > 0 && e.stroke();
      }), !0 === fe && I(e, ai, Ye, Ie), !0 === ne && x(e, ri, Ye), e.restore(), He.forEach(function (i) {
        w(e, D({}, i, {
          data: Ue,
          containerWidth: qe,
          containerHeight: ze,
          theme: Ye
        }));
      });
    }
  }, [Xe, qe, ze, Je, Ke, Pe.top, Pe.left, Q, $e, _e, Ze, Ue, ni, ne, ri, fe, ai, Ie, He, Ye]);

  var oi = e(function () {
    return Ue.map(function (e) {
      return D({
        id: e.id
      }, e.arc);
    });
  }, [Ue]),
      di = function (e) {
    if (!Xe.current) return null;
    var i = b(Xe.current, e),
        t = i[0],
        n = i[1],
        r = M(Pe.left + $e, Pe.top + _e, ei, ii, oi, t, n);
    return r ? Ue.find(function (e) {
      return e.id === r.id;
    }) : null;
  },
      li = E(),
      si = li.showTooltipFromEvent,
      ci = li.hideTooltip,
      ui = function (e) {
    var i = di(e);
    i ? (null == Ge || Ge(i, e), ti(i.id), si(n(De, {
      datum: i
    }), e)) : (ti(null), ci());
  };

  return W("canvas", {
    ref: Xe,
    width: Je * Q,
    height: Ke * Q,
    style: {
      width: Je,
      height: Ke,
      cursor: Ve ? "auto" : "normal"
    },
    onMouseEnter: Ve ? ui : void 0,
    onMouseMove: Ve ? ui : void 0,
    onMouseLeave: Ve ? function () {
      ci();
    } : void 0,
    onClick: Ve ? function (e) {
      if (Be) {
        var i = di(e);
        i && Be(i, e);
      }
    } : void 0
  });
},
    ie = function (e) {
  var i = e.isInteractive,
      t = void 0 === i ? Y.isInteractive : i,
      n = e.theme,
      r = e.renderWrapper,
      a = F(e, _);
  return W(u, {
    isInteractive: t,
    renderWrapper: r,
    theme: n,
    children: W(ee, D({
      isInteractive: t
    }, a))
  });
},
    te = function (e) {
  return W(L, {
    children: function (i) {
      var t = i.width,
          n = i.height;
      return W(ie, D({
        width: t,
        height: n
      }, e));
    }
  });
};

export { Z as Pie, ie as PieCanvas, $ as ResponsivePie, te as ResponsivePieCanvas, Y as defaultProps, P as useNormalizedData, z as usePie, q as usePieArcs, J as usePieFromBox, K as usePieLayerContext };